import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CreateOrderService } from '../click-it/create-order/cement/Services/create-order.service';
import { AuthServicesService } from '../auth/services/auth-services.service';
import { ToastrService } from 'ngx-toastr';
import { clearReducer } from '../auth/state/auth.actions';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { UtilsService } from '../shared/services/utils.service';
@Injectable()
export class AuthorizationInterceptor implements HttpInterceptor {
  localData: any;
  acceptLang: any;
  constructor(
    private readonly store: Store<any>,
    private readonly createOrderService: CreateOrderService,
    private readonly authService: AuthServicesService,
    private readonly toastr: ToastrService,
    private readonly router: Router,
    private readonly utilService: UtilsService,
  ) {
    this.store
      .select((state) => state)
      .subscribe((data) => {
        this.localData = data?.authReducer;
      });
    if (this.localData?.userDetails?.country?.locale) {
      this.acceptLang = this.localData?.userDetails?.country?.locale;
    } else {
      this.acceptLang = navigator.language;
    }
  }
  errorDetectArray: any = [
    'fetch_products',
    'plants',
    'fetch_payers',
    'fetch_partner_ship_tos',
  ];

  token: any;
  intercept( //NoSonar
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
 // 1. FIX: Clean double slashes in incoming request URL (e.g. .io//businesses -> .io/businesses)
    const sanitizedUrl = request.url.replace(/([^:]\/)\/+/g, '$1');
    const v3API = ['/re_order', '/latest_orders', '/fetch_balance', '/dashboards', '/dashboard_banners'];

    const isV3API = v3API.some(url => request.url.includes(url));
    console.log(this.localData?.businessDetails?.cement_system, request, 'testing');
    // '/sap_digital_orders'
    const ZondaUrl = ['/delete_sdo', '/cancel_order', '/order_filters']
    let ZondaUrlToCheck = ZondaUrl.some(url => request.url.includes(url))
    console.log(request.method, request.url, request.url, 'cheking');

    if (request.method == 'GET' && request.url.includes('sap_digital_orders') || request.url.includes('order_filters')) {
      const currentUrl = this.router.url;
      ZondaUrlToCheck = currentUrl.includes('cement') || localStorage.getItem('integration_system') == 'ZONDA_CEMENT';
    }
    const targetUrl = ZondaUrlToCheck && (this.localData?.businessDetails?.cement_system == 'ZONDA' || localStorage.getItem('integration_system') == 'ZONDA_CEMENT');
    console.log(targetUrl, 'testing');


    const modifiedRequest = request.clone({
      url: sanitizedUrl, // Set cleaned URL
      headers: request.headers
        .append('Pragma', 'no-cache')
        .append('Accept-Language', `${this.acceptLang}`)
        .append('Accept', 'application/hal+json')
        .append('Expires', '0')
        .append('Cache-Control', 'no-cache')
        .append('Api-From', 'WebApp')
        .append(
          'X-SYS',
          `${this.localData?.otpVerifiedDetails?.digital_order_system}`
        )
        .append(
          'x-token-authorization',
          `${this.localData?.otpVerifiedDetails?._user_token}`
        )
        .append('AppVersion', isV3API ? 'v3' : 'v1')
        .append('X-Version', environment.HEROKU_RELEASE_VERSION)
        .append('Permissions-Policy', 'camera=(), microphone=(), geolocation=()')
        .append('App-Name', 'HOLCIM')
        .append('x-product-category', targetUrl ? 'CementZonda' : '')
    });
    return next.handle(modifiedRequest).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 || error.status === 406) {
          const isAlreadyOnLogin = this.router.url.includes('login');

          // 2. FIX: Prevent infinite reload loop when background calls fail on /login
          if (isAlreadyOnLogin) {
            return EMPTY;
          }
          this.authService.storeData(error.error);

          error.status === 401 ? this.toastr.error('Session Timedout. Please login again!') : this.toastr.error('Something went wrong with your credentials and you have been logged out.Please login again!')
          this.store.dispatch(clearReducer());
          this.router.navigate(['login']);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
        this.errorCodeHandleMethod(error)
        let errorMsg = '';
        if (error.error instanceof ErrorEvent) {
          errorMsg = `Error: ${error.error.message}`;
        } else {
          console.log("error coming from here", error);


          if (error?.error?.ordering_disable) {
            errorMsg = `Error Code: ${error.status},  Message: ${error.message}, ordering_disable:${error?.error?.ordering_disable}`;
          } else {
            errorMsg = `Error Code: ${error.status},  Message: ${error.message}`;
          }
        }
        if (
          this.errorDetectArray?.includes(
            error?.url
              ?.split('/')
            [error?.url?.split('/').length - 1].split('?')[0]
          )
        ) {
          this.createOrderService.setError(true);
        }

        return throwError(() => errorMsg);
      })
    );
  }
  errorCodeHandleMethod(error) {
    if (error.status === 400) {
      console.log(error, 'test');

      error.error?.message ? localStorage.setItem('errorMessage', JSON.stringify(error.error?.message)) : localStorage.setItem('errorMessage', JSON.stringify(error.error?.messsage))
      error?.status ? localStorage.setItem('errorStatus', error.status.toString()) : localStorage.setItem('errorStatus', error.status.toString()) //NoSonar
      localStorage.setItem('paymentError', error?.error?.stop_payment_process.toString())
    }
    if (error.status === 422) {
      localStorage.setItem('errorMessage', 'Unprocessable Entity');
    }
    if (error.status === 403) {
      console.log(error.status, error)
      localStorage.setItem('corsPolcyMessage', 'Access temporarly blocked due to security reasons. Please try again after 3 hours');
    }
    if (error.status === 425) {
      this.utilService.setUpdatedStatus(true)
    }
    if (error.status === 450) {
      localStorage.setItem('loginData', JSON.stringify(error.error.data))
      this.utilService.setClickitUser(true)
    }
    if (error.status === 500) {
      this.createOrderService.setError(true);
    }
  
  if (error.status === 504) {
    this.toastr.warning('Server response took too long. Please refresh or try again shortly.', 'Timeout');
  }
  }
}
